import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';

@Component({
  selector: 'app-edit-item',
  templateUrl: './edit-item.component.html',
})
export class EditItemComponent {
  constructor(private router: Router, private auth: AuthService) { }

  ngOnInit() {
    if (!this.auth.isAuthenticated([UserType.Agent])) {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
